export default __webpack_public_path__ + "static/media/wifi-0.1c2a4814.svg";